import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CategoriesContainerComponent } from './categories-container.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        CategoriesContainerComponent
    ],
    exports: [
        CategoriesContainerComponent
    ],
    providers: []
})
export class CategoriesContainerModule {}
